import { render, staticRenderFns } from "./InventoryEquipmentView.vue?vue&type=template&id=b8135b54&"
import script from "./InventoryEquipmentView.vue?vue&type=script&lang=js&"
export * from "./InventoryEquipmentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InventoryEquipmentView.vue"
export default component.exports